import React, { FC } from 'react';
import { getImage } from '../../../../app/utlis/imageConstants';
import DynamicSVG from '../../../atoms/DynamicSvg/DynamicSvg';
import { motion } from 'framer-motion';

interface BitEuWebContentProps {
  bitEuProject: any;
}

const BitEuWebContent: FC<BitEuWebContentProps> = ({ bitEuProject }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const itemVariants = {
    hidden: {
      y: 40,
      opacity: 0,
    },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: 'spring',
        stiffness: 100,
        damping: 12,
      },
    },
  };

  return (
    <section className="w-full px-4 sm:px-6 lg:px-12 xl:px-20">
      <motion.div
        className="
          grid
          grid-cols-1
          md:grid-cols-2
          gap-4
          md:gap-6
          py-8
          lg:py-16
        "
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: false, amount: 0.2 }}
      >
        {bitEuProject?.bitEuProjectDetails?.websiteDetails?.map(
          (detail: any, index: number) => {
            const img = getImage(detail?.image ?? '') ?? '';

            return (
              <motion.div
                key={index}
                variants={itemVariants}
                className="h-full"
              >
                <motion.div
                  className="
                    bg-blackDark
                    rounded-3xl
                    p-4
                    sm:p-5
                    lg:p-6
                    flex
                    items-center
                    gap-4
                    h-full
                    min-h-[120px]
                  "
                  whileHover={{ scale: 1.02 }}
                  transition={{
                    type: 'spring',
                    stiffness: 400,
                    damping: 17,
                  }}
                >
                  {/* Icon */}
                  <motion.div
                    className="
                      flex-shrink-0
                      w-14 h-14
                      sm:w-16 sm:h-16
                      lg:w-20 lg:h-20
                      rounded-full
                      bg-biteuColor
                      flex
                      items-center
                      justify-center
                    "
                    whileHover={{ rotate: [0, 10, -10, 0] }}
                    transition={{ duration: 0.5 }}
                  >
                    <DynamicSVG color="#000">
                      {img}
                    </DynamicSVG>
                  </motion.div>

                  {/* Content */}
                  <div className="flex-1 min-w-0">
                    <h3
                      className="
                        text-white
                        font-semibold
                        text-base
                        sm:text-lg
                        lg:text-xl
                        leading-tight
                        break-words
                      "
                    >
                      {detail.title}
                    </h3>

                    <p
                      className="
                        text-[#E0E0E0]
                        text-sm
                        sm:text-base
                        mt-2
                        leading-relaxed
                        break-words
                      "
                    >
                      {detail.sub_title}
                    </p>
                  </div>
                </motion.div>
              </motion.div>
            );
          }
        )}
      </motion.div>
    </section>
  );
};

export default BitEuWebContent;